import mondaySdk from "monday-sdk-js";

class MondayClient {
  constructor() {
    this.monday = mondaySdk();
    // Remove token setting as it's handled automatically by the SDK
    // when running inside Monday.com
  }

  async query(query, variables = {}) {
    try {
      const response = await this.monday.api(query, { variables });
      return response.data;
    } catch (error) {
      console.error('Monday API Error:', error);
      throw error;
    }
  }

  async getContext() {
    try {
      const response = await this.monday.get('context');
      return response.data;
    } catch (error) {
      console.error('Error getting context:', error);
      throw error;
    }
  }

  async getSettings() {
    try {
      const response = await this.monday.get('settings');
      return response.data;
    } catch (error) {
      console.error('Error getting settings:', error);
      throw error;
    }
  }

  async createItem(boardId, itemName, columnValues) {
    const query = `
      mutation create_item ($boardId: Int!, $itemName: String!, $columnValues: JSON!) {
        create_item (board_id: $boardId, item_name: $itemName, column_values: $columnValues) {
          id
        }
      }
    `;

    return this.query(query, {
      boardId,
      itemName,
      columnValues: JSON.stringify(columnValues)
    });
  }
}

export default new MondayClient(); 